import React, { useEffect } from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {Button, message, Steps,Modal } from 'antd';
import {useState} from 'react'
import '../css/main.css'
import {FcOk,FcCancel} from 'react-icons/fc'
import axios from 'axios';
import { ccaa_actions } from '../store/ccaa_slice';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';




//monarch_ccaa_components
import Annual_Net_Conservation from './monarch_ccaa_components/Annual_Net_Conservation';
import Annual_reporting_summary from './monarch_ccaa_components/Annual_Reporting_Summary';
import Summary_Effectiveness from '../components/monarch_ccaa_components/Summary_Effectiveness';
import Upcoming_Year_Forecast from '../components/monarch_ccaa_components/Upcoming_Year_Forecast';
import Monarch_form_values from './monarch_ccaa_components/monarch_form_values';
import MonarchResultsPdf from './monarch_ccaa_components/MonarchResultsPdf';

import {
  Checkbox,
  Spinner,
  Input
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Title from 'antd/lib/skeleton/Title';



const { Step } = Steps;


const steps = [
    {
        title: 'Annual Reporting Summary',
        content: <Annual_reporting_summary />,
    },
    {
        title: 'Annual Net Conservation',
        content: <Annual_Net_Conservation />,
    },
    {
        title: 'Effectiveness Monitoring',
        content: <Summary_Effectiveness />,
    },
    {
        title: 'Upcoming Year Forecast',
        content: <Upcoming_Year_Forecast />,
    },
    {
        title: 'Summary of Report',
        content: <Monarch_form_values />,
    }
];

function MonarchCCAA() {

    const [current, setCurrent] = useState(0);
    //redux
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isCertified, setIsCertified] = useState(false);


    //modal constants
    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [open3, setOpen3] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [confirmLoading2, setConfirmLoading2] = React.useState(false);
    const [confirmLoading3, setConfirmLoading3] = React.useState(false);
    const [modalText, setModalText] = React.useState('Content of the modal');
    const [modalText2, setModalText2] = React.useState('Submitting Values to ROWHWG');
    const [modalText3, setModalText3] = React.useState('Sending Confirmation Email');
    const [logout_status, setLogout_status] = useState(false);
    const [emailList, setEmailList] = useState([]);
    const application_staus = 'Submitted the Annual Reporting Form'
    const [emailCount, setEmailCount] = useState(1);
    const [dataFormatted, setDataFormatted] = useState(false);

    const annual_reporting_summary_store = useSelector(state => state.ccaa.annual_reporting_summary_store);
    const annual_net_conservation_store = useSelector(state => state.ccaa.annual_net_conservation_store);
    const summary_of_effectiveness_store = useSelector(state => state.ccaa.summary_effectiveness_store);
    const upcoming_year_forecast_store = useSelector(state => state.ccaa.upcoming_year_forecast_store);
    const organization_name = useSelector(state => state.ccaa.organization_name_store);
    const logout_store = useSelector(state => state.ccaa.logout_action);
    const home_page_store = useSelector(state => state.ccaa.home_page);

    //data transformations
    const conservation_measures = {
      'conservation_mowing': 'Conservation Mowing',
      'habitat_set_asides': 'Habitat set-asides or idle lands',
      'targeted_herbicide':'Targeted herbicide treatments',
      'seeding_or_planting':'Seeding or planting of habitat',
      'brush_removal':'Brush removal',
      'prescribed_burning':'Prescribed burning',
      'prescribed_grazing':'Prescribed grazing',
      'overwintering_protection':'Overwintering protection measures'
    }

    const supplement_measures = {
      'spatially_focused':'Spatially-focused conservation delivery',
      'incorporate_pollinator':'Incorporate pollinator habitat IVM objectives',
      'invasive_species_prevention':'Invasive species prevention best management practices',
      'additional_pollinator_habitat':'Additional pollinator habitat monitoring',
      'promote_supplemental_pollinator':'Promote supplemenal pollinator conservation',
      'none':'None'
    }

    const updates_to_section_7 = {
      'update_section_7_yes':'Yes',
      'update_section_7_no':'No updates to Section 7'
    }

    const adaptive_management_triggered = {
      'adaptive_management_actions_yes':'Yes',
      'adaptive_management_actions_no':'No'
    }


    //modal functions
    const showModal = () => {
        setOpen(true);
        document.getElementsByClassName("invalid-certify")[0].style.display = "none";
        if(isCertified){
          setIsCertified(false);
        }
      };
      const handleOk = () => {
        if(isCertified){
          //get div with class name "invalid-certify" and set display to none
          document.getElementsByClassName("invalid-certify")[0].style.display = "none";
          //dispatch results to ROWHWG website
          postAnnualNetConservation(true);
          postAnnualReportingSummary(true);
          postSummaryOfEffectiveness(true);
          postUpcomingYearForecast(true);
          sessionStorage.setItem('form_posted',true)
          //showModal2();
          setConfirmLoading(true);
          setTimeout(() => {
            //sendConfirmationEmail();
            setOpen(false);
            setConfirmLoading(false);
            showModal3();
            //dispatch(ccaa_actions.reset_ccca_slice());
            //navigate('/Login')
          }, 10000);
        }
        else{
          //get div with class name "invalid-certify" and set display to block
          document.getElementsByClassName("invalid-certify")[0].style.display = "block";
        }
      };
      const handleCancel = () => {
        setOpen(false);
      };

    //email message in html format including all the form values

    // const email_message = `
    // <html>
    // <head>
    // <style>
    // table, th, td {
    //   border: 1px solid black;
    //   border-collapse: collapse;
    // }
    // th, td {
    //   padding: 5px;
    //   text-align: left;
    // }
    // </style>
    // </head>
    // <body>

    // <p>Thanks for submitting the Annual Reporting Form</p>

    // <h1>Organization Name: ${organization_name}</h1>

    // <h1>Application Status: ${application_staus}</h1>

    // <h2>Annual Reporting Summary</h2>
    // <table style="width:100%">
    // <tr>
    //   <th>Acres Enrolled</th>
    //   <th>Acres Target</th>
    //   <th>Acres Contributed</th>
    //   <th>Aditional Explanation</th>
    // </tr>
    // <tr>
    //   <td>${annual_reporting_summary_store.acres_enrolled}</td>
    //   <td>${annual_reporting_summary_store.acres_target}</td>
    //   <td>${annual_reporting_summary_store.acres_contributed}</td>
    //   <td>${annual_reporting_summary_store.additional_explanation}</td>
    // </tr>
    // </table>
    // <h2>Annual Net Conservation</h2>
    // <table style="width:100%">
    // <tr>
    //   <th>Conservation Measures</th>
    //   <th>Conservation Measures Implementation</th>
    //   <th>Partners Overlap</th>
    //   <th>Supplement Measures</th>
    //   <th>Additional Supplement Conservation Measures</th>
    //   <th>Updates to Section 7</th>
    // </tr>
    // <tr>
    //   <td>${annual_net_conservation_store.conservation_measures}</td>
    //   <td>${annual_net_conservation_store.conservation_measures_implementation}</td>
    //   <td>${annual_net_conservation_store.partners_overlap}</td>
    //   <td>${annual_net_conservation_store.supplement_measures}</td>
    //   <td>${annual_net_conservation_store.additional_supplement_conservation_measures}</td>
    //   <td>${annual_net_conservation_store.updates_to_section_7}</td>
    //   </tr>
    // </table>
    // <h2>Summary of Effectiveness</h2>
    // <table style="width:100%">
    // <tr>
    //   <th>Methods Effective Monitoring</th>
    //   <th>Monitoring Results Summary</th>
    //   <th>Adaptive Management Triggered</th>
    //   <th>Adaptive Management Actions</th>
    //   <th>Supplemental Effectiveness Monitoring</th>
    // </tr>
    // <tr>
    //   <td>${summary_of_effectiveness_store.methods_effective_monitoring}</td>
    //   <td>${summary_of_effectiveness_store.monitoring_results_summary}</td>
    //   <td>${summary_of_effectiveness_store.adaptive_management_triggered}</td>
    //   <td>${summary_of_effectiveness_store.adaptive_management_actions}</td>
    //   <td>${summary_of_effectiveness_store.supplemental_effectiveness_monitoring}</td>
    //   </tr>
    // </table>
    // <h2>Upcoming Year Forecast</h2>
    // <table style="width:100%">
    // <tr>
    //   <th>Anticipate Updates</th>
    //   <th>General Comments</th>
    // </tr>
    // <tr>
    //   <td>${upcoming_year_forecast_store.anticipate_updates}</td>
    //   <td>${upcoming_year_forecast_store.general_comments}</td>
    // </tr>
    // </table>
    // </body>
    // </html>
    // `

    const email_body = `Thank you for submitting the annual reporting form. Find your attached annual report summary.`

    // const sendConfirmationEmail = async () => {
    //   try{
    //     const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/mail_route/v1/mail_route_post', {
    //       "to": "coreil4@uic.edu",
    //       "subject":"Submission of Annual Reporting Form (Submission)",
    //       "message": email_message
    //     })
    //   }
    //   catch(error){
    //     //console.log(error)
    //   }
    // }

    // const sendConfirmationEmailUser = async () => {
    //   try{
    //     const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/mail_route/v1/mail_route_post', {
    //       "to": String(sessionStorage.getItem('user_name')),
    //       "subject":"Submission of Annual Reporting Form",
    //       "message": email_message
    //     })
    //   }
    //   catch(error){
    //     //console.log(error)
    //   }
    // }

    const next = () => {
      setCurrent(current + 1);
      window.scrollTo(0, 0)
      switch((steps[current].title)){
        case 'Annual Reporting Summary':
          postAnnualReportingSummary(false);
          //close modal
          break;
        case 'Annual Net Conservation':
          postAnnualNetConservation(false);
          break;
        case 'Summary of Effectiveness':
          postSummaryOfEffectiveness(false);
          break;
        case 'Upcoming Year Forecast':
          postUpcomingYearForecast(false);
          break;
        default:
          break;
      }
    };

    const save = () => {
      window.scrollTo(0, 0)
      switch((steps[current].title)){
        case 'Annual Reporting Summary':
          postAnnualReportingSummary(false);
          //alert("Saved Annual Reporting Summary")
          setTimeout(() => {
            //create a material ui alert
            message.success('Saved Annual Reporting Summary');
          }, 5000);
          //close modal
          break;
        case 'Annual Net Conservation':
          postAnnualNetConservation(false);
          //alert("Saved Annual Net Conservation")
          setTimeout(() => {
            //create a material ui alert
            message.success('Saved Annual Net Conservation');
          }, 5000);
          break;
        case 'Summary of Effectiveness':
          postSummaryOfEffectiveness(false);
          //alert("Saved Summary of Effectiveness")
          setTimeout(() => {
            //create a material ui alert
            message.success('Saved Summary of Effectiveness');
          }, 5000);
          break;
        case 'Upcoming Year Forecast':
          postUpcomingYearForecast(false);
          //alert("Saved Upcoming Year Forecast")
          setTimeout(() => {
            //create a material ui alert
            message.success('Saved Upcoming Year Forecast');
          }, 5000);
          break;
        default:
          break;
      }
    };


    const prev = () => {
      setCurrent(current - 1);
      window.scrollTo(0, 0)
    };

    const items = steps.map((item)=>({
        key: item.title,
        title: item.title,
    }));

    //redux store values

    //API POST FUNCTIONS
    const postAnnualReportingSummary = async (modal_bool) => {
      try {
         const annual_reporting_post_data =  {
          "organization_name": organization_name,
          "acres_enrolled": annual_reporting_summary_store.acres_enrolled,
          "acres_target": annual_reporting_summary_store.acres_target,
          "acres_contributed": annual_reporting_summary_store.acres_contributed,
          "additional_explanation": annual_reporting_summary_store.additional_explanation
      }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/annual_reporting_route/v1/annual_reporting_post',annual_reporting_post_data);
         //console.log('annual reporting response', response.data)
         if(modal_bool){
          showModal2();
          setModalText2('Annual Reporting Summary has been submitted'+response.data);
         }
         return response;
     }
  catch(error){
        return error;
      }
    }

    const postAnnualNetConservation = async (modal_bool) => {
      try {
          const annual_net_conservation_post_data =  {
            "organization_name": organization_name,
            "conservation_measures": annual_net_conservation_store.conservation_measures.toString(),
            "conservation_measures_implementation": annual_net_conservation_store.conservation_measures_implementation,
            "partners_overlap": annual_net_conservation_store.partners_overlap,
            "supplement_measures": annual_net_conservation_store.supplement_measures.toString(),
            "additional_supplement_conservation_measures": annual_net_conservation_store.additional_supplement_conservation_measures,
            "updates_to_section_7": annual_net_conservation_store.updates_to_section_7.toString()
            }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/annual_net_conservation_route/v1/annual_net_conservation_post',annual_net_conservation_post_data);
          if(modal_bool){
            showModal2();
            setModalText2("Annual Net Conservation has been submitted");
          }
         return response;
     }
  catch(error){
        return error
      }
    }

    const postSummaryOfEffectiveness = async (modal_bool) => {
      try {
        const summary_of_effectiveness_post_data =  {
          "organization_name": organization_name,
          "methods_effective_monitoring": summary_of_effectiveness_store.methods_effective_monitoring,
          "monitoring_results_summary": summary_of_effectiveness_store.monitoring_results_summary,
          "adaptive_management_triggered": summary_of_effectiveness_store.adaptive_management_triggered.toString(),
          "adaptive_management_actions": summary_of_effectiveness_store.adaptive_management_actions,
          "supplemental_effectiveness_monitoring": summary_of_effectiveness_store.supplemental_effectiveness_monitoring
        }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/summary_effectiveness_route/v1/summary_effectiveness_post',summary_of_effectiveness_post_data);
        if(modal_bool){
          showModal2();
          setModalText2("Summary of Effectiveness has been submitted");
        }
         return response;

     }
  catch(error){
        return error
      }
    }


    const postUpcomingYearForecast = async (modal_bool) => {
      try {
        const upcoming_year_forecast_post_data =  {
          "organization_name": organization_name,
          "anticipate_updates": upcoming_year_forecast_store.anticipate_updates,
          "suggestions_for_ccaa": upcoming_year_forecast_store.suggestions_for_ccaa,
          "general_comments": upcoming_year_forecast_store.general_comments
        }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/upcoming_year_forecast_route/v1/upcoming_year_forecast_post',upcoming_year_forecast_post_data);
        if(modal_bool){
          showModal2();
          setModalText2("Upcoming Year Forecast has been submitted");
        }
         return response;
     }
  catch(error){
        return error
      }
    }

    const annual_reporting_summary_check = () => {
      const not_filled_arr = []
      for (const [key, value] of Object.entries(annual_reporting_summary_store)) {
        if(value!=null && value.length <= 0){
          not_filled_arr.push(key)
          return false;
        }
      }
      return true;
    }

    const annual_net_conservation_check = () => {
      const not_filled_arr = []
      for (const [key, value] of Object.entries(annual_net_conservation_store)) {
        if(value!=null && value.length <= 0){
          not_filled_arr.push(key)
          return false;
        }
      }
      return true;
    }

    const summary_of_effectiveness_check = () => {
      const not_filled_arr = []
      for (const [key, value] of Object.entries(summary_of_effectiveness_store)) {
        if(value!=null && value.length <= 0){
          not_filled_arr.push(key)
          return false;
        }
      }
      return true;
    }

    const upcoming_year_forecast_check = () => {
      const not_filled_arr = []
      for (const [key, value] of Object.entries(upcoming_year_forecast_store)) {
        if(value!=null && value.length <= 0){
          not_filled_arr.push(key)
          return false;
        }
      }
      return true;
    }

    const handleCertify = () => {
      setIsCertified(!isCertified);
    }

    const handleEmail  = (fileName) => {
      //console.log('handle file upload')
      const formData = new FormData();
      formData.append('org_name', organization_name);
      formData.append('file_name', fileName);
      formData.append('to', emailList.length > 1 ? emailList : String(emailList[0]));
      formData.append('subject', 'Monarch CCAA Annual Reporting Form');
      formData.append('message', email_body);


      try {
        const response = axios.post('https://rightofway.erc.uic.edu/wp-json/mail_route/v1/mail_route_pdf', formData
        , {
          headers: {
            'Content-Type': 'multipart/form-data', // Specify 'multipart/form-data' content type
          },
        });
        //console.log('pdf upload response', response);
      } catch (error) {
        console.error(error);
      }
    }

    const handleDataFormatting = () => {

      // Make copies of the original Redux store values
      const formattedAnnualReportingSummary = { ...annual_reporting_summary_store };
      const formattedAnnualNetConservation = { ...annual_net_conservation_store };
      const formattedSummaryOfEffectiveness = { ...summary_of_effectiveness_store };
      const formattedUpcomingYearForecast = { ...upcoming_year_forecast_store };


      // Edit the copies
      formattedAnnualReportingSummary.acres_enrolled = parseInt(formattedAnnualReportingSummary.acres_enrolled).toLocaleString("en-US");
      formattedAnnualReportingSummary.acres_target = parseInt(formattedAnnualReportingSummary.acres_target).toLocaleString("en-US");
      formattedAnnualReportingSummary.acres_contributed = parseInt(formattedAnnualReportingSummary.acres_contributed).toLocaleString("en-US");


      formattedAnnualNetConservation.conservation_measures = formattedAnnualNetConservation.conservation_measures.map(item => {
        return conservation_measures[item] || item;
      });

      formattedAnnualNetConservation.supplement_measures = formattedAnnualNetConservation.supplement_measures.map(item => {
        return supplement_measures[item] || item;
      });

      formattedAnnualNetConservation.updates_to_section_7 = updates_to_section_7[formattedAnnualNetConservation.updates_to_section_7] || formattedAnnualNetConservation.updates_to_section_7;

      formattedSummaryOfEffectiveness.adaptive_management_triggered = adaptive_management_triggered[formattedSummaryOfEffectiveness.adaptive_management_triggered] || formattedSummaryOfEffectiveness.adaptive_management_triggered;


      setDataFormatted(true);

      return [formattedAnnualReportingSummary, formattedAnnualNetConservation, formattedSummaryOfEffectiveness, formattedUpcomingYearForecast];
    }


    const handleFileUpload = async () => {
      //console.log('email list handleEmail function', emailList);


      let pdf_annual_reporting_summary_store, pdf_annual_net_conservation_store, pdf_summary_of_effectiveness_store, pdf_upcoming_year_forecast_store;

      if (dataFormatted) {
        [pdf_annual_reporting_summary_store, pdf_annual_net_conservation_store, pdf_summary_of_effectiveness_store, pdf_upcoming_year_forecast_store] = handleDataFormatting();
      } else {
        pdf_annual_reporting_summary_store = annual_reporting_summary_store;
        pdf_annual_net_conservation_store = annual_net_conservation_store;
        pdf_summary_of_effectiveness_store = summary_of_effectiveness_store;
        pdf_upcoming_year_forecast_store = upcoming_year_forecast_store;
      }

      const pdfBlob = await pdf(
        <MonarchResultsPdf
          home_page_store={home_page_store}
          annual_reporting_summary_store={pdf_annual_reporting_summary_store}
          annual_net_conservation_store={pdf_annual_net_conservation_store}
          summary_of_effectiveness_store={pdf_summary_of_effectiveness_store}
          upcoming_year_forecast_store={pdf_upcoming_year_forecast_store}
          organization_name={organization_name}
        />
      ).toBlob();

      let dateObj = new Date();
      let month = dateObj.getMonth() + 1; // months from 1-12
      let day = dateObj.getDate();
      let year = dateObj.getFullYear();
      let hour = dateObj.getHours();
      let minute = dateObj.getMinutes();
      let mdyt = month + "_" + day + "_" + year + "_" + hour + minute;

      //console.log('pdf blob', pdfBlob);

      const pdfFileName = 'Monarch_CCAA_Results_' + organization_name + '.pdf';

      saveAs(pdfBlob, pdfFileName);

      // Upload the file to the server

      const formData = new FormData();
      formData.append('file', pdfBlob, pdfFileName);

      formData.append('org_name', organization_name);

      try {
        const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/ccaa_route/v1/files', formData, {
          headers: {
            'Content-Type': 'multipart/form-data', // Specify 'multipart/form-data' content type
          },
        });
        //console.log('pdf upload response', response);
        if(response.data.status==='success'){
          handleEmail(pdfFileName);
        }
      } catch (error) {
        console.error(error);
      }
    };




    const handleLogout = () => {
      // //console.log('handle logout inside monarch function')
    }

    const showModal2 = () => {
      setOpen2(true);

    };

    const handleOk2 = () => {
      setConfirmLoading2(true);
      setTimeout(() => {
        setOpen2(false);
        setConfirmLoading2(false);
        //dispatch(ccaa_actions.reset_ccca_slice());
        showModal3();
        //navigate('login')
      }, 2000);
    }

    const handleCancel2 = () => {
      setOpen2(false);
    };

    const showModal3 = () => {
      //console.log('show modal 3')
      handleDataFormatting();
      setOpen3(true);
    };

    const handleOk3 = () => {
      setConfirmLoading3(true);
      setTimeout(() => {
        setOpen3(false);
        setConfirmLoading3(false);
        handleFileUpload();
        //dispatch(ccaa_actions.reset_ccca_slice());
        navigate('/Confirmation')
      }, 2000);
    }

    const handleCancel3 = () => {
      setOpen3(false);
    };

    useEffect(() => {
      if(isCertified){
        setIsCertified(!isCertified);
      }
    }, [open])

    useEffect(() => {
    }, [isCertified])

    useEffect(() => {
      //console.log('email list ue', emailList)
    }
    , [emailList])


    return (
      <div>
        <>
        <Modal
          title="Checking Form Status"
          visible={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          okText="Submit"
        >
          <div>
            <div className='row border rounded-2'>
              <div className='row'>
                  <div className='col-3'>
                  <span><FcOk/></span>
                  </div>
                  <div className='col-9'>
                  <span>Completed</span>
                  </div>
              </div>
              <div className='row'>
                  <div className='col-3'>
                   <span><FcCancel/></span>
                  </div>
                  <div className='col-9'>
                    <span>Incomplete</span>
                  </div>
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-md-6'>
                <span>Annual_Reporting_Summary:</span>
              </div>
              <div className='col-md-6'>
                {(annual_reporting_summary_check())?<FcOk/>:<FcCancel/>}
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <span>Annual_Net_Conservation:</span>
              </div>
              <div className='col-md-6'>
                {(annual_net_conservation_check())?<FcOk/>:<FcCancel/>}
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <span>Summary_Effectiveness:</span>
              </div>
              <div className='col-md-6'>
                {(summary_of_effectiveness_check())?<FcOk/>:<FcCancel/>}
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <span>Upcoming_Year_Forecast:</span>
              </div>
              <div className='mb-2 col-md-6'>
                {(upcoming_year_forecast_check())?<FcOk/>:<FcCancel/>}
              </div>
            </div>
            <br/>
            <div>
              <span>Please confirm before submitting that your report is complete and accurate to the best of your ability and that you have included the following supporting documentation:</span>
            </div>
            <div className='row'>
              <ol>
                  <li>A copy of your implementation Compliance Tracking spreadsheet</li>
                  <li> A copy of your Effectiveness Monitoring spreadsheet</li>
                  <li>A map displaying the locations where monitoring was conducted</li>
                  <li> Documentation necessary to support your supplemental measure discounts, if applicable</li>
               </ol>
            </div>
            <div className='mt-2 row'>
                {/* checkbox to certify the submission of the supporting documentation */}
                <Checkbox onChange={handleCertify} isChecked={isCertified}>I certify that I have included the supporting documentation listed above.</Checkbox>
            </div>
            <div className='invalid-certify text-danger'>
                <span>Please Certify before submission</span>
            </div>
          </div>
        </Modal>
        <Modal
          title="Submitting Results to ROWHWG"
          visible={open2}
          onOk={handleOk2}
          confirmLoading={confirmLoading2}
          onCancel={handleCancel2}
          okText="Logout"
          okButtonProps={{ style: { display: 'none' } }}
          cancelButtonProps={{ style: { display: 'none' } }}
          >
          <div>
            <span>{modalText2} <Spinner/></span>
          </div>
        </Modal>
        <Modal
  title="Email Confirmation"
  visible={open3}
  onOk={handleOk3}
  confirmLoading={confirmLoading3}
  onCancel={handleCancel3}
  okText="Send Email"
>
  <div>
    <div>
      <span>
        Please list out email addresses below to send a confirmation email
      </span>
      <div className='mt-3 d-flex flex-column'>
        {Array.from(Array(emailCount), (e, i) => (
          <div className="d-flex justify-content-around">
            <div className='row'>
                <div className='col-10'>
                      <Input
                    className='mt-2'
                    key={i}
                    placeholder="Enter Email"
                    onBlur={(e) => {
                      //console.log('email list', e.target.value);
                      //if email is not in the list, add it to the list , else do nothing
                      if(!emailList.includes(e.target.value)){
                        setEmailList([...emailList, e.target.value]);
                      }
                    }}
                  />
                </div>
                <div className='col-2'>
                  <button
                className="m-2 btn btn-sm cancel__button"
                onClick={() => {
                  if(emailCount > 1){
                    setEmailList(emailList.filter((item, index) => index !== i));
                    setEmailCount(emailCount - 1);
                  }
                }
                }
              >
                &#x2716; {/* Unicode for "✖" (cross) */}
              </button>
                </div>
            </div>
          </div>
        )
        )}
      </div>
      <div className='d-flex justify-content-end'>
        <button className='btn btn-secondary mt-4 btn-sm' onClick={() => {
          setEmailCount(emailCount + 1);
        }}>
          Add Email
        </button>
      </div>
    </div>
  </div>
</Modal>

        <Steps current={current}>
        {steps.map((option, index) => {
            return (
            <Step key={option.title} title={option.title} />
            );
        }
        )}
      </Steps>
      <div className="steps-content">{steps[current].content}</div>
      <div className='row mb-4'>
        <div className='col-6 d-flex justify-content-center'>
          {current < steps.length - 1 && (
            <Button className='' type="primary" onClick={() => save()}>
              Save Responses
            </Button>
          )}
        </div>
        <div className="col-6 d-flex justify-content-center">
        {current < steps.length - 1 && (
          <Button className='' type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button className='' type="primary" onClick={showModal}>
            Done
          </Button>
        )}
        {current > 0 && (
          <Button className=''
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}
      </div>
      </div>
    </>
      </div>
    )}




export default MonarchCCAA

export const test_monarch = (props,component) => {
    // //console.log('test functions props',props)
    // //console.log('function component',component)
  }
